module.exports = __webpack_public_path__ + "img/32.6153d2d7.jpg";